export const PATTERN = {
    DOB: '^[0-9]{2}/{1}[0-9]{2}/{1}[0-9]{4}',
};
